






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IHeightStyle } from "@/@types/styles/height";
import { IBackgroundImage } from "@/@types/styles/background-image";
import { preferred_language } from "@/config/languags.config.json";
import { IRouteCity } from "@/@types/routeInfo/route-info";

@Component({})
export default class RouteCitysDemo extends Vue {
  @Prop({ type: Object, default: null }) card!: IRouteCity;
  @Prop({ type: String, default: preferred_language }) language!: string;
  show = false;
  showMarkdown = true;

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  cityImage: IBackgroundImage = {
    backgroundImage: null,
  };

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  @Watch("card", { deep: true })
  startBackgroundImage(): void {
    if (this.card) {
      this.cityImage.backgroundImage = `url(${this.$getWebImage(
        this.card.image.name,
        "routeInfo"
      )})`;
    }
  }

  mounted(): void {
    this.calculateHeight();
    this.startBackgroundImage();
  }
}
